<template>
  <div class="main-bas">
    <div class="title-jibne">实名认证</div>

    <el-steps :active="active" finish-status="success" class="stepscc">
      <el-step title="选择身份"></el-step>
      <el-step title="填写信息"></el-step>
    </el-steps>

    <!-- Unnamed (动态面板) -->
    <div class="unslider" v-if="active == 0">
      <div @click="next(1)">
        <div><i class="el-icon-user"></i></div>
        <div>个人</div>
      </div>
      <div @click="next(2)">
        <div><i class="el-icon-house"></i></div>
        <div>企业</div>
      </div>
    </div>

    <!-- 个人填写信息 -->
    <el-form ref="formName" :model="form" label-width="200px" v-if="clickinfo == 1" class="form-aut" :rules="rules">
      <el-form-item label="姓名：" prop="certName">
        <el-input v-model="form.certName"></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="certificateType">
        <el-select v-model="form.certificateType" placeholder="请选择证件类型" disabled>
          <el-option :label="item.label" :value="item.value" v-for="item in certificateTypeList"
            :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码" prop="certificateNumber">
        <el-input
          v-model="form.certificateNumber"
          :disabled="isUpd"
          @input="handlePersonalCertNoInput"
          @blur="handlePersonalCertNoBlur"
        ></el-input>
      </el-form-item>
      <el-form-item label="证件地址：" prop="address">
        <el-input v-model="form.address"></el-input>
         <div class="dxgegaseg address-tip">地址请填写证件上的地址，一个标点符号都不能少，包括括号和括号里面的字。不要删字！也不要增加字！</div>
      </el-form-item>

      <el-form-item label="出生日期：" prop="identityStartTime">
        <el-date-picker placeholder="选择日期" v-model="form.identityStartTime" value-format="yyyy-MM-dd" disabled></el-date-picker>
      </el-form-item>
      <el-form-item label="证件有效期起始日期：" prop="certificateStartTime">
        <el-date-picker v-model="form.certificateStartTime" placeholder="选择日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="证件有效期结束日期：" prop="certificateEndTime">
        <el-date-picker :disabled="form.longTermValid" v-model="form.certificateEndTime" placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-switch class="switch-sfdaes" @change="changeSwitch" v-model="form.longTermValid" active-text="长期有效"
          inactive-text="">
        </el-switch>
        <div class="dxgegaseg">长期有效选择时间为2999年12月31日</div>
      </el-form-item>
      <el-form-item label="证件上传：">
        <div class="avatar-uploader-box">
          <div>
            <div>身份证人像面</div>
            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeAvatarUpload"
              :auto-upload="false" :on-change="handleChange" accept="image/*">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="avatar-uploader-box-fan">
            <div>身份证国徽面</div>
            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeAvatarUpload"
              :auto-upload="false" :on-change="handleChangeFan" accept="image/*">
              <img v-if="imageUrlFan" :src="imageUrlFan" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </el-form-item>

      <!-- <el-form-item label="手机号：" prop="phone">
        <div class="shoujihao-cc">
          <el-input v-model="form.phone" width="80"></el-input>
        </div>
      </el-form-item> -->

      <el-form-item>
        <el-button :loading="loading" type="primary" @click="onSubmit('formName')">{{
      this.realInformation.certName ? "确认更新" : "确认提交"
    }}</el-button>
      </el-form-item>
    </el-form>

    <!-- 企业填写信息 -->
    <el-form ref="formName" :model="form" label-width="200px" v-if="clickinfo == 2" class="form-aut" :rules="rules">
      <el-form-item label="机构名称：" prop="certName">
        <el-input v-model="form.certName"></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="certificateType">
        <el-select v-model="form.certificateType" placeholder="请选择证件类型">
          <el-option :label="item.label" :value="item.value" v-for="item in certificateTypeqiyeList"
            :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码" prop="certificateNumber">
        <el-input v-model="form.certificateNumber" :disabled="isUpd"></el-input>
      </el-form-item>
      <el-form-item label="注册地址：" prop="address">
        <el-input v-model="form.address"></el-input>
        <div class="dxgegaseg address-tip">地址请完全按照营业执照地址填写，不要加字，也不要删减字，包括括号和括号里面的内容</div>
      </el-form-item>

      <el-form-item label="成立时间：" prop="identityStartTime">
        <el-date-picker placeholder="选择日期" v-model="form.identityStartTime" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="营业期限起始日期：" prop="certificateStartTime">
        <el-date-picker v-model="form.certificateStartTime" placeholder="选择日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="营业期限结束日期：" prop="certificateEndTime">
        <el-date-picker :disabled="form.longTermValid" v-model="form.certificateEndTime" placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-switch class="switch-sfdaes" @change="changeSwitch" v-model="form.longTermValid" active-text="长期有效"
          inactive-text="">
        </el-switch>
        <div class="dxgegaseg">长期有效选择时间为2999年12月31日</div>
      </el-form-item>
      <el-form-item label="证件上传：">
        <div class="avatar-uploader-box">
          <div>
            <div>营业执照</div>
            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeAvatarUpload"
              :auto-upload="false" :on-change="handleChange" accept="image/*">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="法人姓名：" prop="legalPersonCertName">
        <el-input v-model="form.legalPersonCertName"></el-input>
      </el-form-item>
      <el-form-item label="法人证件类型" prop="legalPersonCertType">
        <el-select v-model="form.legalPersonCertType" placeholder="请选择证件类型">
          <el-option :label="item.label" :value="item.value" v-for="item in certificateTypeList"
            :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="法人身份证号" prop="legalPersonCertNo">
        <el-input v-model="form.legalPersonCertNo"></el-input>
      </el-form-item>

      <!-- 企业实名暂不采集经办人，改由签署/发票页补填；恢复时取消下方注释即可
      <div class="agent-section-divider"></div>

      <el-form-item label="经办人姓名：" prop="agentCertName">
        <el-input
          :value="form.agentCertName"
          placeholder="请输入经办人姓名"
          @input="handleAgentNameInput"
        ></el-input>
      </el-form-item>
      <el-form-item label="经办人身份证号：" prop="agentCertNo">
        <el-input
          :value="form.agentCertNo"
          maxlength="30"
          placeholder="请输入18位身份证号"
          @input="handleAgentCertNoInput"
        ></el-input>
        <div class="agent-tip">经办人涉及到著作权人签章，请正确填写</div>
      </el-form-item>
      -->

      <!-- <el-form-item label="手机号：" prop="phone">
        <div class="shoujihao-cc">
          <el-input v-model="form.phone" width="80"></el-input>
        </div>
      </el-form-item> -->

      <el-form-item>
        <el-button :loading="loading" type="primary" @click="onSubmit('formName')">确认提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { upload, userSave, addDci, userUpdate, updateDci } from "@/api/user.js";
import {
  isSimpleIdCardNumber,
  normalizeAgentName,
  normalizeIdCardNumber,
} from "@/utils/agentInfo.js";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    // 企业实名暂不采集经办人，恢复校验时同步取消注释
    // const validateAgentCertNo = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error("请输入经办人身份证号"));
    //     return;
    //   }
    //   if (!isSimpleIdCardNumber(value)) {
    //     callback(new Error("请输入18位身份证号，最后一位为数字或X"));
    //     return;
    //   }
    //   callback();
    // };

    return {
      loading: false,
      active: 0,
      clickinfo: 0,
      form: {
        certName: "",
        address: "",
        //证件反面文件路径
        certificateBackFileId: "",
        // 证件反面文件路径 本系统
        certificateBackFileIdLocal: "",
        // 证件正面文件路径
        certificateFrontFileId: "",
        // 证件正面文件路径-本系统oss
        certificateFrontFileIdLocal: "",
        // 证件有效终止时间，格式为yyyy-MM-dd 如果是永久有效建议传2999-12-31。系统会校验与证件照上的有效期终止时间，不一致会走人审
        certificateEndTime: "",
        //证件有效开始时间，格式为yyyy-MM-dd
        certificateStartTime: "",
        // 证件号码
        certificateNumber: "",
        // 证件类型
        certificateType: "",
        // 企业成立日期或个人出生日期格式为yyyy-MM-dd
        identityStartTime: "",
        // 法人名称 企业用户必填，个人用户不需要
        legalPersonCertName: "",
        // 法人身份证号 企业用户必填，个人用户不需要
        legalPersonCertNo: "",
        // 法人证件类型 企业用户必填，个人用户不需要
        legalPersonCertType: "",
        // 经办人姓名 企业用户必填，个人用户不需要
        agentCertName: "",
        // 经办人身份证号 企业用户必填，个人用户不需要
        agentCertNo: "",
        // 证件有效期类型 不传默认读取证件照上的字段，证件照是否长期有效，长期有效为true，否则为false
        longTermValid: false,
        // DCI用户的手机号
        phone: "",
        // 用户id，本系统用户表id
        userId: "",
        // 短信验证码 必填
        verifyCode: "666",
      },
      // 证件类型个人 选项
      certificateTypeList: [
        { value: "IDENTITY_CARD", label: "身份证" },
        {
          value: "OTHER",
          label: "其它（当注册用户是事业单位等其它类型时，证件类型为其它）",
        },
      ],
      // 证件类型企业 选项
      certificateTypeqiyeList: [
        { value: "NATIONAL_LEGAL_MERGE", label: "统⼀社会信⽤代码" },
        {
          value: "OTHER",
          label: "其它（当注册用户是事业单位等其它类型时，证件类型为其它）",
        },
      ],
      // 身份证正面
      imageUrl: "",
      imageUrlFile: "",
      // 身份证反面
      imageUrlFan: "",
      imageUrlFanFile: "",
      rules: {
        certName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        certificateType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        certificateNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        identityStartTime: [
          {
            required: true,
            message: "请输入出生日期",
            trigger: "change",
          },
        ],
        certificateStartTime: [
          {
            required: true,
            message: "请输入证件有效期起始日期",
            trigger: "change",
          },
        ],
        certificateEndTime: [
          {
            required: true,
            message: "请输入证件有效期结束日期",
            trigger: "change",
          },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        legalPersonCertName: [
          { required: true, message: "请输入法人姓名", trigger: "blur" },
        ],
        legalPersonCertType: [
          { required: true, message: "请选择法人证件类型", trigger: "blur" },
        ],
        legalPersonCertNo: [
          { required: true, message: "请输入法人身份证号", trigger: "blur" },
        ],
        // 企业实名暂不采集经办人，恢复 UI 时同步取消注释
        // agentCertName: [
        //   { required: true, message: "请输入经办人姓名", trigger: "blur" },
        // ],
        // agentCertNo: [
        //   { required: true, validator: validateAgentCertNo, trigger: "blur" },
        // ],
      },
      value1: false,
      isUpd: false, // 是否是修改
    };
  },
  computed: {},
  watch: {},
  async created() {
    if (this.realInformation.certName) {
      this.form = { ...this.form, ...this.realInformation };
      console.log(this.realInformation,'this.realInformation============');
      
      this.active = 1;
      this.isUpd = true
      if (this.form.certificateBackFileIdLocal) {
        const certificateBackUrl = await this.$download.file(
          this.form.certificateBackFileIdLocal
        );
        this.imageUrlFan = URL.createObjectURL(certificateBackUrl);
      }
      if (this.form.certificateFrontFileIdLocal) {
        const certificatekUrl = await this.$download.file(
          this.form.certificateFrontFileIdLocal
        );
        this.imageUrl = URL.createObjectURL(certificatekUrl);
      }

      if (this.isPersonal) {
        this.clickinfo = 1;
        this.form.certificateType = "IDENTITY_CARD";
      } else {
        this.clickinfo = 2;
      }
    }
  },
  computed: {
    // 计算属性绑定到Vuex store中的userInfo
    realInformation() {
      return this.$store.state.realInformation;
    },
    isPersonal() {
      return this.realInformation.legalPersonCertName ? false : true;
    },
  },
  watch: {
    async realInformation(newVal) {
      if (newVal.certName) {
        this.form = { ...this.form, ...newVal };
        this.active = 1;

        if (this.form.certificateBackFileIdLocal) {
          const certificateBackUrl = await this.$download.file(
            this.form.certificateBackFileIdLocal
          );
          this.imageUrlFan = URL.createObjectURL(certificateBackUrl);
        }
        if (this.form.certificateFrontFileIdLocal) {
          const certificatekUrl = await this.$download.file(
            this.form.certificateFrontFileIdLocal
          );
          this.imageUrl = URL.createObjectURL(certificatekUrl);
        }

        if (newVal.legalPersonCertName) {
          this.clickinfo = 2;
        } else {
          this.clickinfo = 1;
          this.form.certificateType = "IDENTITY_CARD";
        }
      }
    },
  },
  mounted() { },
  methods: {
    handlePersonalCertNoInput(value) {
      if (this.form.certificateType === "IDENTITY_CARD") {
        this.form.certificateNumber = normalizeIdCardNumber(value);
      }
    },
    // 个人实名：证件号失焦后，合法身份证才自动填充出生日期
    handlePersonalCertNoBlur() {
      if (this.clickinfo !== 1) return;
      const idNo = normalizeIdCardNumber(this.form.certificateNumber);
      if (!isSimpleIdCardNumber(idNo)) return;
      const birthStr = idNo.slice(6, 14);
      const year = Number(birthStr.slice(0, 4));
      const month = Number(birthStr.slice(4, 6));
      const day = Number(birthStr.slice(6, 8));
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() + 1 !== month ||
        date.getDate() !== day
      ) {
        return;
      }
      this.form.identityStartTime = `${birthStr.slice(0, 4)}-${birthStr.slice(4, 6)}-${birthStr.slice(6, 8)}`;
    },
    handleAgentNameInput(value) {
      this.form.agentCertName = normalizeAgentName(value);
    },
    handleAgentCertNoInput(value) {
      this.form.agentCertNo = normalizeIdCardNumber(value);
    },
    changeSwitch(val) {
      this.form.longTermValid = val;
      if (val) {
        this.form.certificateEndTime = "2999-12-31";
      } else {
        this.form.certificateEndTime = "";
      }
    },
    next(index) {
      this.active = 1;
      this.clickinfo = index;
      if (index === 1) {
        this.form.certificateType = "IDENTITY_CARD";
      }
    },
    onSubmit(formName) {
      if (this.clickinfo === 1 && this.form.certificateType === "IDENTITY_CARD") {
        this.form.certificateNumber = normalizeIdCardNumber(this.form.certificateNumber);
      }
      // 企业实名暂不采集经办人，恢复 UI 时同步取消注释
      // if (this.clickinfo === 2) {
      //   this.form.agentCertName = normalizeAgentName(this.form.agentCertName);
      //   this.form.agentCertNo = normalizeIdCardNumber(this.form.agentCertNo);
      // }
      console.log(this.form.longTermValid);
      this.$refs[formName].validate(async (valid) => {

        if (valid) {
          this.loading = true;
          // 禁用按钮5秒
          setTimeout(() => {
            this.loading = false;

          }, 5000);


          // 文件不提交先
          if (this.imageUrlFile) {
            // 证件正面文件路径
            let FrontFileId = new FormData();
            FrontFileId.append("file", this.imageUrlFile);
            const resFront = await upload(FrontFileId);
            if (resFront.code == 200) {
              this.form.certificateFrontFileId = resFront.dciFile;
              this.form.certificateFrontFileIdLocal = resFront.ossFile;
            } else {
              this.$message.error(resFront.msg);

              return false;
            }
          }
          if (this.imageUrlFanFile) {
            // 证件反面文件路径
            let eBackFileId = new FormData();
            eBackFileId.append("file", this.imageUrlFanFile);
            const resBack = await upload(eBackFileId);
            if (resBack.code == 200) {
              this.form.certificateBackFileId = resBack.dciFile;
              this.form.certificateBackFileIdLocal = resBack.ossFile;
            } else {
              this.$message.error(resBack.msg);
              return false;
            }
          }

          this.form.phone = this.$store.state.userInfo.user.phonenumber; // 手机号
          this.form.userId = this.$store.state.userInfo.user.userId; // 用户id
          console.log(this.form, "this.form-----------");
          

          const submitData = { ...this.form };
          if (this.clickinfo === 1) {
            delete submitData.agentCertName;
            delete submitData.agentCertNo;
          }
          console.log(submitData, "submitData-----------");

          let res = {};
          if (this.realInformation.certName) {
            res = await userUpdate(submitData);
          } else {
            res = await userSave(submitData);
          }

          if (res.code == 200) {
            this.$message.success("保存用户信息成功");
          } else {
            this.$message.error("保存用户信息失败" + res.msg);
            return false;
          }

          let resDci = {};
          if (this.realInformation.dciUserId) {
            resDci = await updateDci({
              userId: this.$store.state.userInfo.user.userId,
            });
          } else {
            resDci = await addDci({
              userId: this.$store.state.userInfo.user.userId,
            });
          }

          console.log(resDci, "resDci");



          if (res.code == 200) {
            this.$message.success("提交DCI成功");
            this.$router.push({
              path: "/AccountCenter/RealnameAuthentication",
            });
            window.location.reload();
          } else {
            this.$message.error("提交DCI失败" + res.msg);
            return false;
          }
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },
    handleChange(file) {
      // 验证文件大小
      if (file.size > 5 * 1024 * 1024) {
        const error = "文件限制5M以内，请重新上传";
        this.$message.error(error);
        return;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      this.imageUrlFile = file.raw;
    },
    handleChangeFan(file) {
      if (file.size > 5 * 1024 * 1024) {
        const error = "文件限制5M以内，请重新上传";
        this.$message.error(error);
        return;
      }
      this.imageUrlFan = URL.createObjectURL(file.raw);
      this.imageUrlFanFile = file.raw;
    },
    beforeAvatarUpload(file) {
      //   const isJPG = file.type === "image/jpeg";
      //   const isLt2M = file.size / 1024 / 1024 < 2;

      //   if (!isJPG) {
      //     this.$message.error("上传头像图片只能是 JPG 格式!");
      //   }
      //   if (!isLt2M) {
      //     this.$message.error("上传头像图片大小不能超过 2MB!");
      //   }
      //   return isJPG && isLt2M;
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.title-jibne {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
}

.stepscc {
  margin: 30px auto;
  width: 1200px;
}

.unslider {
  margin: 0 auto;
  width: 1200px;
  height: 866px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  >div {
    width: 470px;
    height: 380px;
    border-style: solid;
    border-color: rgba(121, 121, 121, 1);
    border-radius: 10px;
    border-width: 1px;
    text-align: center;
    display: flex;

    &:hover {
      cursor: pointer;
    }

    flex-direction: column;
    justify-content: center;

    > :nth-child(1) {
      font-size: 160px;
    }

    > :nth-child(2) {
      margin: 20px;
      letter-spacing: normal;
      color: #333333;
      line-height: normal;
      font-size: 24px;
      font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
      font-weight: 700;
      font-style: normal;
      white-space: nowrap;
      text-transform: none;
      text-rendering: optimizeLegibility;
      -webkit-font-feature-settings: "kern";
      font-kerning: normal;
    }
  }
}

.xuigaimima {
  margin-left: 50px;
  color: #169bd5;

  &:hover {
    cursor: pointer;
  }
}

.el-input {
  position: relative;
  font-size: 14px;
  width: 390px;
}

.shoujihao-cc {
  display: flex;
}

.form-aut {
  margin: 0 auto;
  width: 800px;
}

.avatar-uploader-box {
  display: flex;
}

.avatar-uploader-box-fan {
  margin-left: 30px;
}

.avatar-uploader {
  width: 260px;
  height: 178px;
  display: block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploade:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 260px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.switch-sfdaes {
  margin-left: 20px;
}

.avatar {
  width: 260px;
  height: 178px;
  display: block;
}

.dxgegaseg {
  font-size: 14px;
  color: red;
}

.agent-tip {
  color: #f56c6c;
  font-size: 13px;
}

.agent-section-divider {
  width: calc(100% - 200px);
  margin: 24px 0 24px 200px;
  border-top: 1px solid #dcdfe6;
}

.address-tip {
  width: 390px;
  line-height: 20px;
  white-space: normal;
}
</style>
